import get from "lodash/get";
import rill from "rill";
import redirect from "@rill/redirect";
import ensureUser from "../../middleware/ensure-user";
import ensureSetup from "../../middleware/ensure-setup";

import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";

function ensureNotSetup({ res, locals }, next) {
  if (get(locals, "activeUser.setup") === "finished") {
    return res.redirect("/dashboard/calendar");
  }
  return next();
}

const Setup = (app) => {
  app
    .get("/setup", redirect("/setup/step1"))
    .at(
      "/setup/*",
      ensureNotSetup,
      rill().setup(Step1).setup(Step2).use(ensureUser, ensureSetup).setup(Step3)
    );
};

export default Setup;
